import React from 'react';
import { buildChatSearchDatePresets } from './chatSearchDatePresetUtils';
import type { ChatSearchDatePreset } from './chatSearchDatePresetUtils';

export type ChatSearchDateRange = {
  startDate: string;
  endDate: string;
};

type ChatSearchDatePresetsProps = {
  startDate?: string | null;
  endDate?: string | null;
  onSelect?: (range: ChatSearchDateRange) => void;
};

/**
 * 公演日フィルタのプリセットチップ（今月・来月・今後・過去 + 日付クリア）。
 * onSelect には { startDate, endDate }（'YYYY-MM-DD' / 空文字）を渡す。
 */
export default function ChatSearchDatePresets({
  startDate = '',
  endDate = '',
  onSelect,
}: ChatSearchDatePresetsProps) {
  const presets: ChatSearchDatePreset[] = buildChatSearchDatePresets();
  const currentStart = String(startDate || '');
  const currentEnd = String(endDate || '');
  const isActive = (preset: ChatSearchDatePreset) =>
    preset.startDate === currentStart && preset.endDate === currentEnd;
  const handleSelect = (next: ChatSearchDateRange) => {
    onSelect?.(next);
  };
  return (
    <div className="chat-target-search-form__presets" role="group" aria-label="公演日プリセット">
      {presets.map((preset) => (
        <button
          key={preset.key}
          type="button"
          className={`chat-target-search-form__preset${isActive(preset) ? ' is-active' : ''}`}
          aria-pressed={isActive(preset)}
          onClick={() => handleSelect({ startDate: preset.startDate, endDate: preset.endDate })}
        >
          {preset.label}
        </button>
      ))}
      {currentStart || currentEnd ? (
        <button
          type="button"
          className="chat-target-search-form__preset chat-target-search-form__preset--clear"
          onClick={() => handleSelect({ startDate: '', endDate: '' })}
        >
          日付クリア
        </button>
      ) : null}
    </div>
  );
}
